import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { SummaryCard } from "./Component/SummaryCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Barcode_Set, Head_Set, Segregation_Init } from "./SliceSegregation";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
import BreadCrumbs from "./Component/BreadCrumbs";
import { SegregationRo, vRdxUserInfo } from "../../Redux/roStore";
import { SegregationSummary_GETROW } from "../../Server/ApiV2";
import CardSummary from "./Component/CardSummary";
import LocationWiseModal from "./Component/LocationWiseModal";
const initialData = [
  // {
  //   A_VocTyp: "PL00027481 ",
  //   A_VocNo: "123",
  //   A_VocDt: "10/16/2024",
  //   L_DropID: "CWH -- ICAD",
  //   LDBAYName: "LOADINGBIN",
  //   L_BaseQty: "POST",
  //   TotalPickedQty: "Manual",
  //   CompletionPercentage: "ENTER",
  // },
];
const SegregationSummary = () => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxHead = useSelector((state) => state.SliceSegregation.value.Head);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Orgdata, setOrgData] = useState([]);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");
  // const [openLocationModal, setOpenLocationModal] = useState(false);

  const handleLoad = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    const Obj = {
      v_UserCd: vRdxUserInfoObj?.UserID,
    };
    let resp = await SegregationSummary_GETROW(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (resp?.status === 200 && resp?.data?.ResultSet?.length > 0) {
      console.log(resp);
      // let respData = resp?.data?.ResultSet;
      const updatedData = resp?.data?.ResultSet.map((item) => {
        let indicator;
        if (item.L_BaseQty -item.TotalPickedQty <=0) {
          indicator = 3; // Green
        } else if (item.TotalPickedQty > 0) {
          indicator = 1; // Yellow
        } else {
          indicator = 2; // Red
        }
        return {
          ...item, // Spread existing properties
          Indicator: indicator, // Add the new key
        };
      })?.sort((a, b) => a.Indicator - b.Indicator);
      setData(updatedData);
      setOrgData(updatedData);
    } else {
      setData([]);
      setOrgData([]);
    }
    setTimeout(async () => {
      document.getElementsByName("SCAN")[0]?.focus();
    }, 100);
    // document.getElementsByName("SCAN")[0]?.focus();
  };
  useEffect(() => {
    handleLoad();
    dispatch(Barcode_Set(""));
    Segregation_Init();
  }, []);

  const handleFilter = (xfilter = filter) => {
    if (xfilter === "") {
      setData(Orgdata);
    } else {
      let filtered = Orgdata.filter((item) => {
        return (
          item.L_DropID.toUpperCase().includes(xfilter) &&
          (item.L_DropID != null ||
            item.L_DropID != "" ||
            item.L_DropID != undefined)
        );
      });

      setData(filtered);
    }
  };
  const fOnRowClick = async (e) => {
    let {
      A_VocTyp,
      A_VocNo,
      A_VocDt,
      L_DropID,
      L_BaseQty,
      TotalPickedQty,
      CompletionPercentage,
      Status,
      SegregationMethod,
    } = e.row;
    dispatch(
      Head_Set({
        ...vRdxHead,
        A_VocTyp: A_VocTyp,
        A_VocNo: A_VocNo,
        A_VocDt: A_VocDt,
        L_DropID: L_DropID,
        L_BaseQty: L_BaseQty,
        TotalPickedQty: TotalPickedQty,
        CompletionPercentage: CompletionPercentage,
        Status: Status,
        SegregationMethod: SegregationMethod || "",
      })
    );
    //open modal
    //setOpenLocationModal(true);

    // navigate("/segregationItemScan");
  };
  return (
    // <div sx={{ margin: {md:"40px" ,sm:"5px" , xs:"5px"} }}>
    <div style={{ margin: vMediaQuery ? "1px" : "40px" }}>
      <div className="d-flex justify-content-between align-items-center">
        <BreadCrumbs />
      </div>
      <Grid
        container
        spacing={0.5}
        style={{ margin: "12px 0px", alignItems: "center" }}
      >
        <Grid item xs={8} md={4}>
          <TextField
            fullWidth
            label="SCAN"
            name="SCAN"
            variant="outlined"
            value={filter}
            onChange={(e) => {
              setFilter(e.target.value);
              // handleFilter((e.target.value).toUpperCase());
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter" || e._reactName === "onClick") {
                handleFilter(filter.toUpperCase());
              }
            }}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0.5,
                borderColor: "#1976d2",
              },
            }}
          />
        </Grid>
        <Grid item xs={"auto"}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => handleFilter(filter.toUpperCase())}
            size="small"
          >
            Load
          </Button>
        </Grid>
      </Grid>
      {/* <SummaryCard
        data={data}
        onClick={(items) => {
          fOnRowClick(items);
        }}
      /> */}
      {/* <CardSummary data={data}
        onClick={(items) => {
          fOnRowClick(items);
        }}/>   */}

      <CardSummary
        data={data}
        Orgdata={Orgdata}
        onClick={(items) => {
          fOnRowClick(items);
        }}
        onClickNext={(item) => {
          // let { LocName, Location,NumberID } = item;
          // dispatch(
          //   Head_Set({
          //     ...vRdxHead,
          //     LocName: LocName,
          //     Location: Location,
          //     NumberID:NumberID
          //   })
          // );
          navigate("/segregationItemScan");
        }}
      />
    </div>
  );
};

export default SegregationSummary;
